import {
  SET_TRAFFIC,
  SET_SHOW_CLOSED_SIG_EVENTS,
  SET_DEFAULT_BASEMAP,
  SET_INCIDENT_DISPLAY_ORDER,
  SET_SIG_EVENT_DISPLAY_ORDER,
  SET_TIMESTAMP_FORMAT,
  FETCH_SUCCESS,
} from './actionTypes'
import { LOGIN_SUCCESS, INIT } from '../auth/actionTypes'
import { PREFERENCES } from './constants'

const initialState = {
  user: null,
  preferences: {},
}

export const NAME = 'user'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRAFFIC:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.SHOW_TRAFFIC]: action.value,
        },
      }
    case SET_SHOW_CLOSED_SIG_EVENTS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.SHOW_CLOSED_SIGEVENTS]: action.value,
        },
      }
    case SET_DEFAULT_BASEMAP:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.DEFAULT_BASEMAP]: action.value,
        },
      }
    case SET_INCIDENT_DISPLAY_ORDER:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.INCIDENT_DISPLAY_ORDER]: action.value,
        },
      }
    case SET_SIG_EVENT_DISPLAY_ORDER:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.SIGEVENT_DISPLAY_ORDER]: action.value,
        },
      }
    case SET_TIMESTAMP_FORMAT:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          [PREFERENCES.TIMESTAMP_FORMAT]: action.value,
        },
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        preferences: action.preferences,
      }
    case INIT:
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.user
          ? {
              name: action.user.name,
              username: action.user.username,
              isAdmin: action.user.isAdmin,
            }
          : {},
        preferences: action.user ? action.user.preferences : {},
      }
    default:
      return state
  }
}

export default reducer
